// NOTE: hooks
import { useMemo } from 'react'
import { Outlet, NavLink, useLocation } from 'react-router-dom'
import { usePermission } from '../../hooks/usePermission'
// NOTE: components
import Container from './Container'
import PageTitle from './PageTitle'
import { Carousel, SwiperSlide } from './carousel/Carousel'

interface SubPageProps {
	title: string,
	links: any
}

const SubPage = ({ title, links }: SubPageProps) => {
	const { isRestricted, user } = usePermission()
	const location = useLocation()

	// NOTE: Filter sub-links based on permissions
	const visibleLinks = useMemo(() => {
		// NOTE: Get the parent path (staff or settings)
		const parentPath = location.pathname.split('/')[1]
		const isManager = user?.team?.managers?.includes(user?.email)

		return links.filter((link: any) => {
			// NOTE: clinic visible if can view settings, not restricted, and is manager
			if (parentPath === 'settings' && link.to === 'clinic') return !isRestricted('settings/clinic') && isManager
			if (parentPath === 'settings' && link.to === 'website') return !isRestricted('settings/clinic') && isManager
			if (parentPath === 'settings' && link.to === 'staff') return !isRestricted('staff') && isManager
			if (parentPath === 'settings' && link.to === 'partners') return !isRestricted('settings/clinic') && isManager

			return true
		})
	}, [links, isRestricted, location.pathname, user?.team, user?.email])

	return (
		<Container className="py-4 md:py-6">
			<PageTitle title={title} className="!mb-2 md:!mb-4" />

			<Carousel className="mb-4">
				{visibleLinks.map((link: any) => (
					<SwiperSlide style={{ width: 'fit-content', minWidth: 'fit-content' }} key={link.to}>
						<NavLink to={link.to} className="mr-4 flex w-fit flex-col">
							{({ isActive }) => (
								<>
									<h2
										className={`${isActive ? 'text-slate-800' : 'text-slate-500'} text-2xl font-medium`}
									>
										{link.text}
									</h2>
									<div
										className={`${isActive ? 'bg-slate-800' : 'bg-slate-400'} h-[2.5px] w-full rounded-2xl`}
									/>
								</>
							)}
						</NavLink>
					</SwiperSlide>
				))}
			</Carousel>

			<Outlet />
		</Container>
	)
}

export default SubPage
